import { Component, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts/highstock';
import { EoptionsService } from 'src/app/services/eoptions.service';

@Component({
    selector: 'app-option-chart',
    templateUrl: './option-chart.component.html',
    styleUrls: ['./option-chart.component.css']
})
export class OptionChartComponent implements OnInit {
    Highcharts: typeof Highcharts = Highcharts;
    chartOptions: Highcharts.Options = {
        chart: {
            backgroundColor: '#161a1e',
            style: {
                fontFamily: 'BinancePlex, Arial, sans-serif'
            }
        },
        rangeSelector: {
            enabled: false
        },
        title: {
            text: ''
        },
        yAxis: {
            gridLineColor: '#2b3139',
            labels: {
                style: { color: '#848e9c' }
            }
        },
        xAxis: {
            lineColor: '#2b3139',
            labels: {
                style: { color: '#848e9c' }
            }
        },
        series: [{
            type: 'candlestick',
            name: 'Price',
            data: [],
            color: '#f6465d',
            upColor: '#0ecb81',
            lineColor: '#f6465d',
            upLineColor: '#0ecb81'
        }],
        navigator: { enabled: false },
        scrollbar: { enabled: false },
        credits: { enabled: false }
    };

    updateFlag = false;
    currentPair = 'BTCUSDT';

    constructor(private eoptionsService: EoptionsService) { }

    ngOnInit(): void {
        this.eoptionsService.selectedPair$.subscribe(pair => {
            if (pair) {
                this.currentPair = pair;
                this.fetchKlines();
            }
        });
        this.fetchKlines();
    }

    fetchKlines() {
        this.eoptionsService.getKlines(this.currentPair).subscribe({
            next: (res: any) => {
                if (res.status && res.data) {
                    this.chartOptions.series = [{
                        type: 'candlestick',
                        name: this.currentPair,
                        data: res.data,
                        color: '#f6465d',
                        upColor: '#0ecb81',
                        lineColor: '#f6465d',
                        upLineColor: '#0ecb81'
                    }];
                    this.updateFlag = true;
                }
            },
            error: (err) => console.error(err)
        });
    }
}
